// @ts-nocheck
// set multiple fields
export const SET_CONTRACTOR_SIGNUP_MULTIPLE_FIELDS =
  "SET_CONTRACTOR_SIGNUP_MULTIPLE_FIELDS";

// contractor signup step1
export const CONTRACTOR_SIGNUP_STEP1_REQUEST =
  "CONTRACTOR_SIGNUP_STEP1_REQUEST";
export const CONTRACTOR_SIGNUP_STEP1_SUCCESS =
  "CONTRACTOR_SIGNUP_STEP1_SUCCESS";
export const CONTRACTOR_SIGNUP_STEP1_FAILURE =
  "CONTRACTOR_SIGNUP_STEP1_FAILURE";

// contractor signup step1 update
export const CONTRACTOR_SIGNUP_STEP1_UPDATE_REQUEST =
  "CONTRACTOR_SIGNUP_STEP1_UPDATE_REQUEST";
export const CONTRACTOR_SIGNUP_STEP1_UPDATE_SUCCESS =
  "CONTRACTOR_SIGNUP_STEP1_UPDATE_SUCCESS";
export const CONTRACTOR_SIGNUP_STEP1_UPDATE_FAILURE =
  "CONTRACTOR_SIGNUP_STEP1_UPDATE_FAILURE";

// contractor signup step2
export const CONTRACTOR_SIGNUP_STEP2_REQUEST =
  "CONTRACTOR_SIGNUP_STEP2_REQUEST";
export const CONTRACTOR_SIGNUP_STEP2_SUCCESS =
  "CONTRACTOR_SIGNUP_STEP2_SUCCESS";
export const CONTRACTOR_SIGNUP_STEP2_FAILURE =
  "CONTRACTOR_SIGNUP_STEP2_FAILURE";

// contractor signup step3
export const CONTRACTOR_SIGNUP_STEP3_REQUEST =
  "CONTRACTOR_SIGNUP_STEP3_REQUEST";
export const CONTRACTOR_SIGNUP_STEP3_SUCCESS =
  "CONTRACTOR_SIGNUP_STEP3_SUCCESS";
export const CONTRACTOR_SIGNUP_STEP3_FAILURE =
  "CONTRACTOR_SIGNUP_STEP3_FAILURE";

// contractor signup step4
export const CONTRACTOR_SIGNUP_STEP4_REQUEST =
  "CONTRACTOR_SIGNUP_STEP4_REQUEST";
export const CONTRACTOR_SIGNUP_STEP4_SUCCESS =
  "CONTRACTOR_SIGNUP_STEP4_SUCCESS";
export const CONTRACTOR_SIGNUP_STEP4_FAILURE =
  "CONTRACTOR_SIGNUP_STEP4_FAILURE";

// contractor signup step5
export const CONTRACTOR_SIGNUP_STEP5_REQUEST =
  "CONTRACTOR_SIGNUP_STEP5_REQUEST";
export const CONTRACTOR_SIGNUP_STEP5_SUCCESS =
  "CONTRACTOR_SIGNUP_STEP5_SUCCESS";
export const CONTRACTOR_SIGNUP_STEP5_FAILURE =
  "CONTRACTOR_SIGNUP_STEP5_FAILURE";
export const UPDATE_CONTRACTOR_CERTIFICATES_SIGNUP_STEP5 =
  "UPDATE_CONTRACTOR_CERTIFICATES_SIGNUP_STEP5";

// Clear contractor signup
export const CLEAR_CONTRACTOR_SIGNUP = "CLEAR_CONTRACTOR_SIGNUP";

// add step 1 form api
export const ADD_STEP_1_FROM_API_REQUEST = "ADD_STEP_1_FROM_API_REQUEST";
export const ADD_STEP_1_FROM_API_SUCCESS = "ADD_STEP_1_FROM_API_SUCCESS";
export const ADD_STEP_1_FROM_API_FAILURE = "ADD_STEP_1_FROM_API_FAILURE";

// add contractor email
export const ADD_CONTRACTOR_EMAIL_REQUEST = "ADD_CONTRACTOR_EMAIL_REQUEST";
export const ADD_CONTRACTOR_EMAIL_SUCCESS = "ADD_CONTRACTOR_EMAIL_SUCCESS";
export const ADD_CONTRACTOR_EMAIL_FAILURE = "ADD_CONTRACTOR_EMAIL_FAILURE";